// extracted by mini-css-extract-plugin
export default {"showMoreLinkButton":"reviewsLevelTravel-module__showMoreLinkButton__xCojT"};